import request from "./../utils/request";

export function getMailList(incoming, userId, mailAddress, pageCount, perPage) {
    return request({
        url: `/mail/my`,
        method: "get",
        params: {
            incoming,
            userId,
            mailAddress,
            pageCount,
            perPage,
        },
    });
}

export function getVisitorMailList(visitorId, mailAddress, pageCount, perPage) {
    return request({
        url: `/mail/visitor`,
        method: "get",
        params: {
            visitorId,
            mailAddress,
            pageCount,
            perPage,
        },
    });
}

export function getUserMailList(userId, mailAddressId, pageCount, perPage) {
    return request({
        url: `/mail/user`,
        method: "get",
        params: {
            userId,
            mailAddressId,
            pageCount,
            perPage,
        },
    });
}

export function getDepartmentOrRepresentativeMails(mailAddress, userId, pageCount, perPage) {
    return request({
        url: `/mail/department`,
        method: "get",
        params: {
            mailAddress,
            userId,
            pageCount,
            perPage,
        },
    });
}

export function getMailDetails(threadId) {
    return request({
        url: `/mail/detail/${threadId}`,
        method: "get",
    });
}

export function cleanUnreadThread(userId, threadId) {
    return request({
        url: `/mail/clean-unread-thread/${userId}/${threadId}`,
        method: "get",
    });
}

export function cleanAllUnreadThread(userId) {
    return request({
        url: `/mail/clean-all-unread-thread/${userId}`,
        method: "get",
    });
}

export function getSearchValueMails(userId, pageCount, perPage, inputValue) {
    return request({
        url: `/mail/search-value-mails`,
        method: "get",
        params: {
            userId,
            inputValue,
            pageCount,
            perPage,
        },
    });
}

export function getUserEmail(userId) {
    return request({
        url: `/mail/userMailAddress/${userId}`,
        method: "get",
    });
}

export function getMailAddressByToList(data) {
    return request({
        url: `/mail/mails-by-to-list`,
        method: "post",
        data,
    });
}

export function createVisitorAndMailAddressMulti(data) {
    return request({
        url: `/mail/visitor-mail-address-multi`,
        method: "post",
        data,
    });
}

export function getMailAddressesByInputValue(userId, inputValue, selectedMailAddress) {
    return request({
        url: `/mail/get-mail-addresses-by-input-value`,
        method: "get",
        params: {
            userId,
            inputValue,
            selectedMailAddress,
        },
    });
}

export function getSenderMailAddressesByInput(userId, inputValue) {
    return request({
        url: `/mail/get-sender-mail-addresses-by-input/${userId}/${inputValue}`,
        method: "get",
    });
}

export function getDepartmentMailAddresses(userId) {
    return request({
        url: `/mail/department-mail-addresses/${userId}`,
        method: "get",
    });
}

export function getAllUnreadMailCount(userId) {
    return request({
        url: `/mail/all-unread-mail-count/${userId}`,
        method: "get",
    });
}

export function deleteThreadMessage(mail) {
    return request({
        url: `/mail/delete-thread-message`,
        method: "post",
        data: mail,
    });
}

export function deleteThread(threadId) {
    return request({
        url: `/mail/delete-thread/${threadId}`,
        method: "delete",
    });
}

export function mailVerification(userId, departmentId, mail) {
    return request({
        url: `/mail/mail-verification/${userId}/${departmentId}/${mail}`,
        method: "get",
    });
}

export function getVisitorsByMailAddress(mailList) {
    return request({
        url: `/visitors/by-mail-address`,
        method: "post",
        data: mailList,
    });
}

export function createMailTemplate(payload) {
    return request({
        url: `/mail/mail-template`,
        method: "post",
        data: payload,
    });
}

export function getUserMediaList(mailAddressId, pageCount, perPage) {
    return request({
        url: `/mail/user-all-medias`,
        method: "get",
        params: {
            mailAddressId,
            pageCount,
            perPage,
        },
    });
}

export function getDepartmentMediaList(departmentName, pageCount, perPage) {
    return request({
        url: `/mail/department-all-medias`,
        method: "get",
        params: {
            departmentName,
            pageCount,
            perPage,
        },
    });
}

export function saveSignature(mailAddress, html) {
    return request({
        url: `/mail/save-signature`,
        method: "post",
        data: {
            mailAddress,
            html,
        },
    });
}

export function getMailSignature(mailAddress) {
    return request({
        url: `/mail/get-signature`,
        method: "get",
        params: {
            mailAddress,
        },
    });
}

export function changeSignatureAutoUse(mailAddress, isAutoAdd) {
    return request({
        url: `/mail/signature-auto-add`,
        method: "put",
        data: {
            mailAddress,
            isAutoAdd,
        },
    });
}

export function changeVisibility(id, mail, visibility) {
    return request({
        url: `/mail/change-visibility/${id}`,
        method: "post",
        data: {
            mail,
            visibility,
        },
    });
}

//ilgili kullanıcı için detay sayfasında görünürlüğü aktif olanları getirir
export function getVisibilityUser(id) {
    return request({
        url: `/mail/user-visibility/${id}`,
        method: "get",
    });
}

// mail sayfasında görebileceği mail adreslerini getirir
export function getVisibilityMailAddress(id) {
    return request({
        url: `/mail/visibility-mail-address/${id}`,
        method: "get",
    });
}

export function createMailAddress(data) {
    return request({
        url: `/mail/mail-address`,
        method: "post",
        data: { data },
    });
}

export function getMailVisitors(data) {
    return request({
        url: `/mail/mail-visitors`,
        method: "get",
        params: data,
    });
}

export function getSenderMailAddress(data) {
    return request({
        url: `/mail/sender-mail-address`,
        method: "get",
        params: data,
    });
}

export function changeDefaultMailAddress(payload) {
    return request({
        url: `/mail/change-default-mail`,
        method: "put",
        data: payload,
    });
}

export function deleteSenderMail(mailAddressId) {
    return request({
        url: `/mail/delete-sender-mail/${mailAddressId}`,
        method: "delete",
    });
}
